export default __webpack_public_path__ + "static/media/barbell.2a459a9a.png";